import { render, staticRenderFns } from "./OnboardingThirdStep.vue?vue&type=template&id=00be4c58&scoped=true"
import script from "./OnboardingThirdStep.vue?vue&type=script&lang=js"
export * from "./OnboardingThirdStep.vue?vue&type=script&lang=js"
import style0 from "./OnboardingThirdStep.vue?vue&type=style&index=0&id=00be4c58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be4c58",
  null
  
)

export default component.exports